export default "__VITE_ASSET__2ba5d750__"